const pixelsCategories = ["PERFORMANCE","TARGETING","SOCIAL"];

export { pixelsCategories };